window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
window.gtag = gtag;
function checkInitializer() {      
    if(!window.ng) {
      document.getElementById('no-angular').style.display="block";
    }
  }